/**
 * 値がnull,undefinedでない状態になったら返す.(※false, 0, ''は返す)
 * @param 値を取得する処理
 * @param maxCount 最大チェック回数
 * @param delayMillis インターバルミリ秒
 * @returns 値が取得できた場合は、その値
 */
export const loadedValuePromise = (valueCallback: () => any, maxCount: number = 20, delayMillis: number = 200) => {
  return new Promise((resolve, reject) => {
    let counter = 0;

    const checkLoaded = () => {
      const value = valueCallback();
      counter++;
      if (value !== null && value !== undefined) {
        clearInterval(intervalId);
        resolve(value);
        return;
      }
      if (maxCount <= counter) {
        clearInterval(intervalId);
        reject(new Error('timeout'))
      }
    }
    const intervalId = setInterval(checkLoaded, delayMillis);
    checkLoaded(); // 初回は即時チェック
  })
};

import { eachSlice } from './collections'
/**
 * chunkSizeで分割して、逐次実施する（chunkSizeの個数は並列で実施）
 * @param argsList 引数のリスト
 * @param chunkSize 並列で実行する個数
 * @param proc 処理
 * @returns 各処理の結果をまとめたリスト
 */
export const processInChunks = async <T, R>(
  argsList: T[],
  chunkSize: number,
  proc: (args: T) => Promise<R>
): Promise<R[]> => {
  const slicedArgsList = eachSlice(argsList, chunkSize)
  const allResults: R[] = []
  for (const chunk of slicedArgsList) {
    const chunkResults = await Promise.all(chunk.map(proc))
    allResults.push(...chunkResults)
  }
  return allResults
}
